module.exports = __webpack_public_path__ + "static/media/featured-image.55659a4e.jpg";